import React, { Component } from "react";
import { connect } from "react-redux";
import client from "config/agent";
import { wsConnect, wsNewMessage, wsDisconnect, wsConnected } from "services/websocket";
import "semantic-ui-css/semantic.min.css";
import { Route, Redirect, withRouter } from "react-router-dom";
import routingConfig from "config/routingConfig";
import { ResponsiveContainer } from "components/ResponsiveHeader";
import { Container, Dimmer, Loader, Responsive, Sidebar } from "semantic-ui-react";
import SidebarContainer from "components/Sidebar/SidebarContainer";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logOutUser, tokenExpired, resetPassword } from "services/auth";
import { resetCenter } from "services/center";
import { resetCenterBox } from "services/box";
import { getAllGeneralParameters } from "services/generalParameter";
import * as jwt from "jsonwebtoken";
import { toggleNurseHelp, getNurseHelp, toggleHelpFolderOfMyCenter } from "services/user";
import { getAssignedToMeFolderHelp, getWaitingFolderHelp, acceptSupportFolderHelp, cancelFolderHelp, doneFolderHelp } from "services/folderHelp";
import { setFocusedFolders, closeAllMyOpenedFolder, getMyOpenedFolders, getFoldersWaitingAliquots } from "services/folder";
import ResetPassword from "./Login/ResetPassword";
import { openDualScreen, closeDualScreen, setDualScreenAvailability } from "services/dualScreen";

import { checkDualScreenAvailability } from "utils/dualScreenUtils";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { goToResult, goToAliquot, resetWaitingAliquots, goToTubes } from "services/folder";
import notificationIcon from "../assets/image/notificationTvSec.png";
import notificationSound2 from "../assets/sounds/mixkit-retro-game-notification-212.wav";
import { setAvailableBox, setBusyBox } from "services/live";
import { qrPreregister } from "services/preregister";
import ConnectSocket from "hooks/ConnectSocket";
import localforage from "localforage";

const containerStyle = {
	WebkitOverflowScrolling: "touch",
	overflowY: "auto",
	overflowX: "hidden",
};

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

class Home extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
			visible: false,
			component: <div>&nbsp;</div>,
			authReady: false,
			showLoader: false,
			openFolderManager: false,
			cancelHelpNurseModal: false,
			cancelFolderId: 0,
			lastGeneralParametersFetchAt: 0,
			//selectedSound: notificationSound,
		};
	}
	setupBeforeUnloadListener = () => {
		window.addEventListener("beforeunload", (ev) => {
			ev.preventDefault();
			return this.props.wsDisconnect();
		});
	};

	componentDidMount() {
		Sentry.setUser({
			id: this.props.user.session.id,
			username: this.props.user.session.name,
		});

		const token = this.props.user.session.token;
		this.setState({ active: true });

		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		window.addEventListener("resize", () => {
			// We execute the same script as before
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});

		if (token !== null) {
			let decodedToken = jwt.decode(token, { complete: true });
			let dateNow = new Date();

			if (decodedToken.payload.exp < dateNow.getTime() / 1000) {
				this.props.tokenExpired();
			} else {
				this.setState({ authReady: true });

				if (this.props.generalParameters.data === null && !this.props.generalParameters.loading) {
					this.setState({ lastGeneralParametersFetchAt: Date.now() });
					this.props.getAllGeneralParameters();
				}
			}

			checkDualScreenAvailability(this.props.setDualScreenAvailability);
		}

		if (!("Notification" in window)) {
			console.log("This browser does not support desktop notification");
		} // Let's check whether notification permissions have alredy been granted
		// Otherwise, we need to ask the user for permission
		else if (Notification.permission !== "granted") {
			Notification.requestPermission();
		}
	}

	componentWillUnmount() {
		this.setState({ active: false });
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const token = this.props.user.session.token;
		if (token !== null) {
			let decodedToken = jwt.decode(token, { complete: true });
			let dateNow = new Date();

			if (decodedToken.payload.exp < dateNow.getTime() / 1000) {
				this.props.tokenExpired();
			} else {
				const canRetry =
					!this.props.generalParameters.loading &&
					this.props.generalParameters.data === null &&
					Date.now() - (this.state.lastGeneralParametersFetchAt || 0) > 10_000;
				if (canRetry) {
					this.setState({ lastGeneralParametersFetchAt: Date.now() });
					this.props.getAllGeneralParameters();
				}
			}

			if (prevProps.tvSecretaryisActivated !== this.props.tvSecretaryisActivated) {
				this.props.getNurseHelp();
			}
		}
		if (this.props.user.session.role === "SECRETARY" && prevProps.myNurseFolderHelps.length === 0 && this.props.myNurseFolderHelps.length === 1) {
			this.showNotification();
		}

		if (
			this.props.user.session.role === "NURSE" &&
			prevProps.myNurseFolderHelps.filter((hf) => hf.status === "REASSIGNED").length <
				this.props.myNurseFolderHelps.filter((hf) => hf.status === "REASSIGNED").length
		) {
			this.showNotificationNurse();
		}
	}

	showNotification = () => {
		if (!("Notification" in window)) {
			console.log("This browser does not support desktop notification");
		} else {
			var options = {
				body: "Un dossier vient de vous être assigné.",
				icon: notificationIcon,
				dir: "ltr",
			};
			new Notification("MyLabNurse : Télésecrétariat", options);
			new Audio(this.props.user.session.soundNotification ?? notificationSound2).play().catch((e) => {
				console.log("Chrome cannot play sound without user interaction first");
			});
		}
	};

	showNotificationNurse = () => {
		if (!("Notification" in window)) {
			console.log("This browser does not support desktop notification");
		} else {
			var options = {
				body: "Une secrétaire a terminé de saisir un de vos dossiers.",
				icon: notificationIcon,
				dir: "ltr",
			};
			new Notification("MyLabNurse : Télésecrétariat", options);
		}
	};

	toggleNurseHelp = () => {
		this.props.toggleNurseHelp().then(() => this.props.getAssignedToMeFolderHelp());
		if (!this.props.user.session.nurseHelp) {
			this.getMyNurseFolderHelps();
		}
	};

	getMyNurseFolderHelps = () => {
		if (
			this.props.user.session.nurseHelp &&
			this.props.generalParameters &&
			this.props.generalParameters.data &&
			this.props.centers.center &&
			this.props.centers.center.isTvSecActivated
		) {
			this.props.getAssignedToMeFolderHelp(this.props.user.session.helpFoldersMyCenter);
		}
	};

	openSidebar = (component) => {
		this.setState({ visible: true, component: component });
	};

	hideSidebar = () => {
		this.setState({ visible: false, component: <div>&nbsp;</div> });
	};

	showSidebarLoader = (show) => {
		this.setState({ showLoader: show });
	};

	cleanUpStorage = async () => {
		localStorage.clear();
		sessionStorage.clear();
		await localforage.clear();
	};

	logout = async () => {
		await this.cleanUpStorage();
		this.props.resetCenter();
		this.props.resetCenterBox();
		this.props.resetWaitingAliquots();
		this.props.logOutUser(this.props.user.session.id, this.props.user.session.refreshToken);
	};
	cancelFolderHelp = async (folderId, comment, reason) => {
		await this.props.cancelFolderHelp(folderId, comment, reason);
	};

	acceptSupport = async (folderId) => {
		await this.props.acceptSupportFolderHelp(folderId);
	};

	focusFolderManager = (focusedFolders) => {
		this.props.setFocusedFolders(focusedFolders);
		//this.setState({ openFolderManager: true });
	};

	openCancelHelpNurseModal = (folderId) => {
		this.setState({ cancelHelpNurseModal: true, cancelFolderId: folderId });
	};

	closeCancelHelpNurseModal = () => {
		this.setState({ cancelHelpNurseModal: false });
	};

	doneFolderHelp = async (folderId) => {
		await this.props.doneFolderHelp(folderId);
	};

	render() {
		const { visible, authReady, showLoader, openFolderManager } = this.state;
		const {
			generalParameters,
			user,
			centers,
			boxes,
			dualScreen,
			openDualScreen,
			closeDualScreen,
			setDualScreenAvailability,
			myNurseFolderHelps,
			statusWaitingFolderHelps,
			foldersWaiting,
			aliquotWaiting,
			myOpenedFolders,
			closeAllMyOpenedFolder,
			goToResult,
			goToAliquot,
			goToTubes,
			ws,
			live,
			setAvailableBox,
			setBusyBox,
		} = this.props;
		const lastPasswordChange = moment().startOf("day").diff(moment(user.session.last_password_change).startOf("day"), "months");

		if (this.props.user.session.token === null && this.props.location.pathname !== "/") {
			this.cleanUpStorage();
			return <Redirect to="/" />;
		} else if (!authReady) {
			return <Loader active />;
		} else if (!generalParameters.data) {
			return <Loader active />;
		} else if (this.props.user.session.resetPassword || lastPasswordChange >= process.env.REACT_APP_PASSWORD_RESET_MONTH) {
			return <ResetPassword resetPassword={this.props.resetPassword} />;
		} else {
			if (openFolderManager) {
				return <Redirect to="/home/foldermanager" />;
			}
			return (
				<>
					<ConnectSocket
						wsConnect={this.props.wsConnect}
						wsConnected={this.props.wsConnected}
						user={this.props.user}
						wsDisconnect={this.props.wsDisconnect}
					/>
					<Sidebar.Pushable>
						{showLoader && (
							<Dimmer active>
								<Loader />
							</Dimmer>
						)}

						<Sidebar direction="right" animation="overlay" icon="labeled" visible={visible} width={isMobile() ? "wide" : "very wide"}>
							<SidebarContainer>{this.state.component}</SidebarContainer>
						</Sidebar>
						<Sidebar.Pusher dimmed={visible}>
							<ResponsiveContainer
								logout={this.logout}
								path={this.props.location.pathname}
								parameters={{
									urlTaking: generalParameters.data.urlTaking,
									urlCatalogExams: generalParameters.data.urlCatalogExams,

									videos: generalParameters.data.videos ? JSON.parse(generalParameters.data.videos) : null,
									center: centers.center,
									box: boxes.box,
									live: live.list,
									tour: centers.tour,
									manualDegradation: generalParameters.data.manualDegradation,
									manualDegradationMessage: generalParameters.data.manualDegradationMessage,
									usualState: generalParameters.data.usualState,
								}}
								user={{
									rights: user.session.rights,
									name: user.session.name,
									role: user.session.role,
									gender: user.session.gender,
									nurseHelp: user.session.nurseHelp,
									helpFoldersMyCenter: user.session.helpFoldersMyCenter,
									id: user.session.id,
								}}
								dualScreen={dualScreen}
								closeDualScreen={closeDualScreen}
								openDualScreen={openDualScreen}
								setDualScreenAvailability={setDualScreenAvailability}
								showSidebarLoader={this.showSidebarLoader}
								toggleNurseHelp={this.toggleNurseHelp}
								myNurseFolderHelps={myNurseFolderHelps}
								statusWaitingFolderHelps={statusWaitingFolderHelps}
								helpNurseGlobalParam={generalParameters.data.helpNurse ?? false}
								foldersWaiting={foldersWaiting}
								focusFolderManager={this.focusFolderManager}
								myOpenedFolders={myOpenedFolders}
								closeAllMyOpenedFolder={closeAllMyOpenedFolder}
								acceptSupportFolderHelp={this.acceptSupport}
								doneFolderHelp={this.doneFolderHelp}
								cancelFolderHelp={this.cancelFolderHelp}
								goToResult={goToResult}
								goToAliquot={goToAliquot}
								goToTubes={goToTubes}
								aliquotWaiting={aliquotWaiting}
								ws={ws}
								setAvailableBox={setAvailableBox}
								setBusyBox={setBusyBox}
								toggleHelpFolderOfMyCenter={() => {
									this.props.getAssignedToMeFolderHelp(!this.props.user.session.helpFoldersMyCenter);
									this.props.toggleHelpFolderOfMyCenter();
								}}
								helpFoldersMyCenter={this.props.user.session.helpFoldersMyCenter}
								openPreregisterModal={this.props.qrPreregister}
								reasonOptions={this.props.reasonOptions}
								queuedFolderHelps={this.props.queuedFolderHelps}
								getWaitingFolderHelp={this.props.getWaitingFolderHelp}
							>
								<div
									style={{
										paddingTop: this.props.location.pathname === "/home/foldermanager" ? (isMobile() ? 0 : 43) : isMobile() ? 0 : 67,
										paddingBottom: isMobile() ? 0 : generalParameters.data.manualDegradation || generalParameters.data.usualState ? 150 : 50,
										...containerStyle,
									}}
									className="mainWrapper"
								>
									<Container style={this.props.location.pathname === "/home/planning" ? { width: "100vw" } : null}>
										{routingConfig.map((route, key) => (
											<RouteWithSubRoutes
												{...route}
												key={key}
												openSidebar={this.openSidebar}
												hideSidebar={this.hideSidebar}
												showSidebarLoader={this.showSidebarLoader}
											/>
										))}

										{this.props.location.pathname === "/home" && <Redirect to="/home/lab" />}
									</Container>
								</div>
							</ResponsiveContainer>
						</Sidebar.Pusher>
					</Sidebar.Pushable>
					<ToastContainer position="bottom-left" autoClose={10000} hideProgressBar={true} transition={Slide} />
				</>
			);
		}
	}
}

function RouteWithSubRoutes(route) {
	return (
		<Route
			path={route.path}
			render={(props) => (
				// pass the sub-routes down to keep nesting
				<route.component
					{...props}
					routes={route.routes}
					openSidebar={route.openSidebar}
					hideSidebar={route.hideSidebar}
					showSidebarLoader={route.showSidebarLoader}
				/>
			)}
		/>
	);
}

const mapStateToProps = (state) => {
	return {
		user: state.user,
		centers: state.centers,
		boxes: state.boxes,
		generalParameters: state.generalParameters,
		dualScreen: state.dualScreen,
		myNurseFolderHelps: state.folderHelp.myNurseFolderHelps,
		statusWaitingFolderHelps: state.folderHelp.statusWaitingFolderHelps,
		tvSecretaryisActivated: state.folderHelp.tvSecretaryisActivated,
		foldersWaiting: state.folderManager.foldersWaiting,
		aliquotWaiting: state.folderManager.aliquotWaiting,
		myOpenedFolders: state.folderManager.myOpenedFolders,
		ws: state.ws,
		live: state.live,
		reasonOptions: state.folderHelp.cancelReasons,
		queuedFolderHelps: state.folderHelp.queuedFolderHelps,
	};
};

const mapDispatchToProps = {
	logOutUser,
	getAllGeneralParameters,
	tokenExpired,
	resetCenter,
	resetPassword,
	openDualScreen,
	closeDualScreen,
	setDualScreenAvailability,
	toggleNurseHelp,
	getAssignedToMeFolderHelp,
	getWaitingFolderHelp,
	setFocusedFolders,
	acceptSupportFolderHelp,
	cancelFolderHelp,
	doneFolderHelp,
	closeAllMyOpenedFolder,
	getMyOpenedFolders,
	getFoldersWaitingAliquots,
	wsConnect,
	wsConnected,
	wsDisconnect,
	wsNewMessage,
	goToResult,
	goToTubes,
	getNurseHelp,
	resetCenterBox,
	setAvailableBox,
	setBusyBox,
	goToAliquot,
	resetWaitingAliquots,
	toggleHelpFolderOfMyCenter,
	qrPreregister,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
